lmApp
  .service('PackageService', ['$q', '$rootScope', function ($q, $rootScope) {
    var service = {};

    service.GetPackages = function (offset, limit) {
      var deferred = $q.defer();

      var url = 'collection/vod.asset/query/dimension/type/eq/package/dimension/package_type/neq/tv_series';

      if (offset && limit) {
        url +=  '/enum/' + offset + ',' + limit;
      }

      url += '?t=' + Date.now();

      lh.common.request(url)
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = url;
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };
    
    service.GetPackageAssets = function (package_id, offset, limit) {
      var deferred = $q.defer();

      var url = 'collection/vod.asset/query/dimension/package_id/eq/' + package_id;

      if (offset && limit) {
        url +=  '/enum/' + offset + ',' + limit;
      }

      url += '?t=' + Date.now();

      lh.common.request(url)
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = url;
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };
    
    service.CreatePackage = function (extid, pkg) {
      var deferred = $q.defer();

      var url = 'asset/mgmt/package/create';

      var data = {
        type: 'generic',
        ext_id: extid + ':' + guid(),
        metadata: {}
      };

      var language = $rootScope.locale;

      data.metadata[language] = {
        'title': pkg._PrivateData.title,
        'description': pkg._PrivateData.description
      };

      data.metadata['_'] = {
        'title': pkg._PrivateData.title,
        'description': pkg._PrivateData.description
      };

      data.metadata = JSON.stringify(data.metadata);

      lh.common.request.post(url, data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = url;
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.SavePackage = function (pkg) {
      var deferred = $q.defer();

      var url = 'asset/mgmt/package/update';

      var data = {
        type: 'generic',
        asset_id: pkg.id,
        metadata: {}
      };

      var language = $rootScope.locale;

      data.metadata[language] = {
        'title': pkg._PrivateData.title,
        'description': pkg._PrivateData.description
      };

      data.metadata['_'] = {
        'title': pkg._PrivateData.title,
        'description': pkg._PrivateData.description
      };

      data.metadata = JSON.stringify(data.metadata);

      lh.common.request.post(url, data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = url;
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.GetPackagePoster = function (pkg) {
      var deferred = $q.defer();

      lh.models.vodAsset.methods.getPosterUrl(pkg)
        .then(function (url) {
          deferred.resolve(url);
        }, function (reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.AddAsset = function (pkg_ids, asset_ids) {
      var deferred = $q.defer();

      var url = 'asset/mgmt/package/asset/assoc';

      var data = {
        package_id: pkg_ids.join(','),
        asset_id: asset_ids.join(',')
      };

      lh.common.request.post(url, data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = url;
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    service.RemoveAsset = function (pkg_ids, asset_ids) {
      var deferred = $q.defer();

      var url = 'asset/mgmt/package/asset/deassoc';

      var data = {
        package_id: pkg_ids.join(','),
        asset_id: asset_ids.join(',')
      };

      lh.common.request.post(url, data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = url;
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    return service;
  }]);
